import { render, staticRenderFns } from "./RegisterLease.vue?vue&type=template&id=3f1c594c"
import script from "./RegisterLease.vue?vue&type=script&lang=ts"
export * from "./RegisterLease.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports